module.exports = {
  "zones": {
    "America/Merida": ["z", {
      "wallclock": 407635200000,
      "format": "C%sT",
      "abbrev": "CST",
      "offset": -21600000,
      "posix": 407653200000,
      "save": 0,
      "rules": "Mexico"
    }, {
      "wallclock": 377913600000,
      "format": "EST",
      "abbrev": "EST",
      "offset": -18000000,
      "posix": 377935200000,
      "save": 0
    }, {
      "wallclock": -1514764708000,
      "format": "CST",
      "abbrev": "CST",
      "offset": -21600000,
      "posix": -1514743200000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -21508000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Mexico": [{
      "from": 2002,
      "to": 1.7976931348623157e+308,
      "month": 3,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 2002,
      "to": 1.7976931348623157e+308,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 2001,
      "to": 2001,
      "month": 4,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 2001,
      "to": 2001,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1996,
      "to": 2000,
      "month": 3,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1996,
      "to": 2000,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1950,
      "to": 1950,
      "month": 1,
      "day": [7, 12],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1950,
      "to": 1950,
      "month": 6,
      "day": [7, 30],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1944,
      "to": 1944,
      "month": 4,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1943,
      "to": 1943,
      "month": 11,
      "day": [7, 16],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "W",
      "saved": 0
    }, {
      "from": 1941,
      "to": 1941,
      "month": 3,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1940,
      "to": 1940,
      "month": 11,
      "day": [7, 9],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1939,
      "to": 1939,
      "month": 1,
      "day": [7, 5],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1939,
      "to": 1939,
      "month": 5,
      "day": [7, 25],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 0
    }]
  }
};